export const iconFontAwesomeMoneyColonSign = (
	<i className="fa-solid fa-colon-sign"></i>
);
